import { render } from "./PaymentRedirectView.vue?vue&type=template&id=ab953d52"
import script from "./PaymentRedirectView.vue?vue&type=script&lang=js"
export * from "./PaymentRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__